import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import tracking from 'dibs-tracking';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { getNumberOfTiles } from '../../utils/adHelpers';
import { getCategory } from '../../utils/categoryHelpers';
import { createFragmentContainer, graphql } from 'react-relay';
import { updateRelayVariables } from '../../actions/sharedRelayVariableActions';
import { ServerVarsContextConsumer } from '../../global/ServerVarsContext/ServerVarsContext';
import {
    isLatestPage,
    getSelectedValue,
    setSelectedValue,
    getPageSizeSelectOptions,
} from './sbRespPageSizeHelpers';

// components
import { BasicSelect } from 'dibs-elements/exports/BasicSelect';

// styles
import styles from './SbRespPageSize.scss';

function trackPageSizeEvent(pageSizeValue) {
    tracking.trackEvent({
        category: 'results page refinement',
        action: 'results displayed',
        label: `${pageSizeValue} results clicked`,
        value: 0,
    });
}

export function SbRespPageSizeComponent({ onChange, pageSize, itemSearch, intl }) {
    const { appliedFilters } = itemSearch;
    const options = getPageSizeSelectOptions(intl);

    if (isLatestPage(appliedFilters)) {
        return null;
    }

    return (
        <ServerVarsContextConsumer>
            {({ isSbAdsEnabled }) => {
                return (
                    <div className={styles.container}>
                        <BasicSelect
                            size="medium"
                            options={options}
                            onChange={e => onChange(e, isSbAdsEnabled)}
                            dataTn="sb-resp-page-size"
                            value={getSelectedValue(pageSize)}
                        />
                    </div>
                );
            }}
        </ServerVarsContextConsumer>
    );
}

SbRespPageSizeComponent.defaultProps = {
    onChange: () => {},
};

SbRespPageSizeComponent.propTypes = {
    intl: intlShape.isRequired,
    onChange: PropTypes.func.isRequired,
    pageSize: PropTypes.number.isRequired,
    itemSearch: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
    const { relayVariables } = state;
    const {
        variables: { first },
    } = relayVariables;
    return {
        pageSize: first,
    };
};

function mapDispatchToProps(dispatch, props) {
    return {
        onChange(e, isSbAdsEnabled) {
            const { itemSearch } = props;
            const { appliedFilters } = itemSearch;
            const category = getCategory(appliedFilters);
            const vertical = get(category, 'values[0].urlLabel', '');

            // set page size in cookies
            setSelectedValue(e.target.value);

            // track event in GA
            trackPageSizeEvent(e.target.value);

            // update relay variables
            dispatch(
                updateRelayVariables({
                    first: getNumberOfTiles({
                        pageSize: parseInt(e.target.value, 10),
                        path: vertical,
                        isSbAdsEnabled,
                    }),
                })
            );
        },
    };
}

export const SbRespPageSize = createFragmentContainer(
    injectIntl(
        connect(
            mapStateToProps,
            mapDispatchToProps
        )(SbRespPageSizeComponent)
    ),
    {
        itemSearch: graphql`
            fragment SbRespPageSize_itemSearch on ItemSearchQueryConnection {
                appliedFilters {
                    name
                    values {
                        urlLabel
                    }
                }
            }
        `,
    }
);
